import React from "react";
import ToastContainer from "./toast";
import { UserProvider } from "./UserContext";

const contextProviders = [ToastContainer, UserProvider];

const AppContextProvider = ({ children }) => {
	return contextProviders.reduceRight(
		(child, ContextProvider) => <ContextProvider>{child}</ContextProvider>,
		children
	);
};

export default AppContextProvider;
